 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-_core-errors-errors-module":"pages-_core-errors-errors-module","components-_core-bh-input-text-editor-bh-input-text-editor-module":"components-_core-bh-input-text-editor-bh-input-text-editor-module","default~manage-cases-manage-cases-module~manage-configuration-manage-configuration-module~manage-das~1b700e54":"default~manage-cases-manage-cases-module~manage-configuration-manage-configuration-module~manage-das~1b700e54","default~manage-users-manage-users-module~pages-manage-users-edit-manage-users-edit-module":"default~manage-users-manage-users-module~pages-manage-users-edit-manage-users-edit-module","pages-manage-users-edit-manage-users-edit-module":"pages-manage-users-edit-manage-users-edit-module","default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~87eebbad":"default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~87eebbad","default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~74183c7e":"default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~74183c7e","default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~899178ea":"default~pages-_core-about-about-module~pages-_core-check-for-updates-check-for-updates-module~pages-~899178ea","pages-_core-feedback-feedback-module":"pages-_core-feedback-feedback-module","default~pages-my-cases-edit-my-cases-edit-module~pages-my-cases-new-my-cases-new-module~pages-peer-c~fdd9a89c":"default~pages-my-cases-edit-my-cases-edit-module~pages-my-cases-new-my-cases-new-module~pages-peer-c~fdd9a89c","default~home-home-module~my-cases-my-cases-module~pages-my-cases-new-my-cases-new-module":"default~home-home-module~my-cases-my-cases-module~pages-my-cases-new-my-cases-new-module","default~pages-my-cases-edit-my-cases-edit-module~pages-my-cases-new-my-cases-new-module":"default~pages-my-cases-edit-my-cases-edit-module~pages-my-cases-new-my-cases-new-module","pages-my-cases-new-my-cases-new-module":"pages-my-cases-new-my-cases-new-module","pages-my-cases-edit-my-cases-edit-module":"pages-my-cases-edit-my-cases-edit-module","pages-peer-cases-article-peer-cases-article-module":"pages-peer-cases-article-peer-cases-article-module","pages-_core-check-for-updates-check-for-updates-module":"pages-_core-check-for-updates-check-for-updates-module","pages-_core-help-forgot-pwd-help-forgot-pwd-module":"pages-_core-help-forgot-pwd-help-forgot-pwd-module","pages-_core-help-help-module":"pages-_core-help-help-module","pages-_core-about-about-module":"pages-_core-about-about-module","pages-_core-my-account-my-account-module":"pages-_core-my-account-my-account-module","pages-_core-share-share-module":"pages-_core-share-share-module","pages-tabs-tabs-module":"pages-tabs-tabs-module","pages-login-login-module":"pages-login-login-module","pages-_core-errors-detail-errors-detail-module":"pages-_core-errors-detail-errors-detail-module","pages-_core-help-no-pin-help-no-pin-module":"pages-_core-help-no-pin-help-no-pin-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","peer-cases-peer-cases-module":"peer-cases-peer-cases-module","default~home-home-module~my-cases-my-cases-module":"default~home-home-module~my-cases-my-cases-module","my-cases-my-cases-module":"my-cases-my-cases-module","home-home-module":"home-home-module","default~manage-cases-manage-cases-module~manage-dictionaries-manage-dictionaries-module~manage-repor~cfe2a378":"default~manage-cases-manage-cases-module~manage-dictionaries-manage-dictionaries-module~manage-repor~cfe2a378","manage-users-manage-users-module":"manage-users-manage-users-module","manage-cases-manage-cases-module":"manage-cases-manage-cases-module","manage-configuration-manage-configuration-module":"manage-configuration-manage-configuration-module","manage-dashboard-manage-dashboard-module":"manage-dashboard-manage-dashboard-module","manage-tabs-manage-tabs-module":"manage-tabs-manage-tabs-module","manage-dictionaries-manage-dictionaries-module":"manage-dictionaries-manage-dictionaries-module","manage-reports-manage-reports-module":"manage-reports-manage-reports-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
